import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const initialState = {
  own_passport: '',
  applicant_eighteen_plus: '',
  mexican_passport: '',
  diplomatic_passport: '',
  passport_expire_two_month: '',
  credit_card_issued_major_bank: '',
  credit_card_purchase: '',
  has_persons_passport: '',
  trip_type: '',
  tourist_entry_visa: '',
  signature_same_as_passport: '',
  first_and_last_name_same_as_passport: '',
  dob_same_as_passport: '',
  contact_id: '',
  id: ''
}

export const eligibilityCheckListSlice = createSlice({
  name: 'speech_check_list',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    initializeEligibilityCheckList: () => ({ ...initialState }),
    setEligibilityCheckList: (state, action) => {
      state[action.payload.name] = action.payload.value
    }
  }
})

export const { setEligibilityCheckList, initializeEligibilityCheckList } =
  eligibilityCheckListSlice.actions
export default eligibilityCheckListSlice.reducer
